"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEXP_ONLY_DIGITS = exports.InputOTPSlot = exports.InputOTPSeparator = exports.InputOTPGroup = exports.InputOTP = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const input_otp_1 = require("input-otp");
Object.defineProperty(exports, "REGEXP_ONLY_DIGITS", { enumerable: true, get: function () { return input_otp_1.REGEXP_ONLY_DIGITS; } });
const utils_1 = require("./utils");
const InputOTP = React.forwardRef(({ className, containerClassName, ...props }, ref) => ((0, jsx_runtime_1.jsx)(input_otp_1.OTPInput, { ref: ref, containerClassName: (0, utils_1.cn)('group flex items-center gap-3 has-[:disabled]:cursor-not-allowed has-[:disabled]:opacity-50', containerClassName), className: (0, utils_1.cn)('flex items-center gap-2', className), ...props })));
exports.InputOTP = InputOTP;
InputOTP.displayName = 'InputOTP';
const InputOTPGroup = React.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, utils_1.cn)('flex items-center gap-2', className), ...props })));
exports.InputOTPGroup = InputOTPGroup;
InputOTPGroup.displayName = 'InputOTPGroup';
const InputOTPSeparator = React.forwardRef(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, utils_1.cn)('mx-2 flex items-center justify-center text-muted-foreground', className), ...props })));
exports.InputOTPSeparator = InputOTPSeparator;
InputOTPSeparator.displayName = 'InputOTPSeparator';
const InputOTPSlot = React.forwardRef(({ char, placeholderChar, hasFakeCaret, isActive, className, ...props }, ref) => {
    var _a;
    return ((0, jsx_runtime_1.jsxs)("div", { ref: ref, "data-state": isActive ? 'active' : undefined, className: (0, utils_1.cn)('relative flex h-14 w-12 items-center justify-center rounded-xl border border-input bg-background text-2xl font-semibold text-foreground shadow-sm transition-all', 'group-hover:border-foreground/20 group-focus-within:border-primary group-focus-within:ring-2 group-focus-within:ring-primary/20', 'data-[state=active]:border-primary data-[state=active]:ring-2 data-[state=active]:ring-primary/30', 'data-[state=inactive]:text-muted-foreground', className), ...props, children: [(0, jsx_runtime_1.jsx)("span", { className: "pointer-events-none", children: (_a = char !== null && char !== void 0 ? char : placeholderChar) !== null && _a !== void 0 ? _a : '\u00a0' }), hasFakeCaret ? ((0, jsx_runtime_1.jsx)("span", { className: "pointer-events-none absolute inset-0 flex items-center justify-center", children: (0, jsx_runtime_1.jsx)("span", { className: "h-6 w-px animate-pulse bg-foreground" }) })) : null] }));
});
exports.InputOTPSlot = InputOTPSlot;
InputOTPSlot.displayName = 'InputOTPSlot';
